import React, { useEffect } from "react";

import { RouterProvider } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { router } from "./navigation/Router";
import { env } from "./utils/env";
import useNotifications from "./hooks/useNotifications";

function App() {
  const { i18n } = useTranslation();
  
  // Initialize notification listener globally
  useNotifications();

  useEffect(() => {
    const lng = localStorage.getItem("language") || "es";
    i18n.changeLanguage(lng);
  }, []);

  return (
      <RouterProvider router={router} />
  );
}

export default App;
